<template>
  <div class="bg-white rounded-xlg">
    <div class="pb-10 rounded-lg p-3 flex items-center">
      <div class="w-6/12 pl-2">
        <h1 class="main-text">Quote Reference #</h1>
        <p class="py-0">
          {{
            refrenceInfo.shipping
              ? refrenceInfo.shipping.shippingReference
              : "N/A"
          }}
        </p>
      </div>
      <div class="w-6/12 pl-2">
        <h1 class="main-text text-right">Date:</h1>
        <p class="py-0 text-right">
          {{
            refrenceInfo.shipping.updatedAt
              ? refrenceInfo.shipping.updatedAt.split("T")[0]
              : "N/A"
          }}
        </p>
      </div>
    </div>

    <div class="text-sm bg-primary-green flex justify-center">
      <div class="w-10/12 py-3 flex items-center">
        <div class="bg-white justify-center items-center w-16 h-16 mr-3 rounded-full inline-flex">
          <span>
            <img src="@/assets/images/ondemand/fluent-arrow.svg" class="w-8" />
          </span>
        </div>
        <div class="text-white">
          <h1 class="text-2xl">Standard Shipping (48 Hrs)</h1>
          <p class="py-1">
            Estimated Delivery Date: 29th May 2022 (If booked today)
          </p>
        </div>
      </div>
    </div>

    <!-- <div class=" mt-[2%] py-4">
      <ServiceCard />
    </div> -->

    <div class="p-3">
      <h2 class="py-20 text-2xl">
        Price From: N{{
          refrenceInfo.totalValue
            ? amountFomatter(refrenceInfo.totalValue)
            : " --"
        }}
      </h2>
      <p class="flex p-3 bg-gray-100">
        <span class="mr-2 mt-2 inline-block">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M8.8 5.6H7.2V4H8.8V5.6ZM8.8 12H7.2V7.2H8.8V12ZM8 0C6.94943 0 5.90914 0.206926 4.93853 0.608964C3.96793 1.011 3.08601 1.60028 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.08601 14.3997 3.96793 14.989 4.93853 15.391C5.90914 15.7931 6.94943 16 8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 6.94943 15.7931 5.90914 15.391 4.93853C14.989 3.96793 14.3997 3.08601 13.6569 2.34315C12.914 1.60028 12.0321 1.011 11.0615 0.608964C10.0909 0.206926 9.05058 0 8 0Z"
              fill="#a0aec0" />
          </svg>
        </span>
        <span>
          Please note that this only non-binding price indication. A shipment
          contract can only be generated through the booking system in
          accordance with the terms and conditions of carriage. The actual price
          and transit time may differ from those quoted above depending on
          available conditions at the point of booking.
        </span>
      </p>
    </div>

    <div class="flex items-center w-full px-6 py-12">
      <div class="w-6/12">
        <button @click="$emit('changeTabs', 'describe-shipping')">
          Cancel
        </button>
      </div>
      <div class="w-6/12 flex justify-end">
        <el-dropdown class="h-full">
          <button :disabled="false"
            class="payment-assign h-full font-semibold bg-primary-navy rounded flex items-center p-3">
            <span class="border-r text-white mr-3 inline-block pr-2">Describe Your Shipment</span>

            <arrow-down-filled />
          </button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <button @click="moveToBvooking">Complete Booking</button>
            </el-dropdown-item>

            <el-dropdown-item>
              <button @click="showPaylink = true">Share Link</button>
            </el-dropdown-item>

            <el-dropdown-item>
              <button @click="navigateToreciept">Preview Quote</button>
            </el-dropdown-item>

            <el-dropdown-item>
              <button @click="navigateToReg">Save Shipment</button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <SharePayLink :paymentParams="paymentParams" @close-modal="showPaylink = false" :showModal="showPaylink" />
  </div>
</template>

<script>
// import ServiceCard from './QuoteServicesCard.vue'
import SharePayLink from "./modals/SharePayLink.vue";

export default {

  components: {
    SharePayLink,
    // ServiceCard 
  },
  data() {
    return {
      refrenceInfo: {},
      showPaylink: false,
    };
  },
  computed: {
    paymentParams() {
      return {
        email: "",
        payAmount: 50,
        paylink: "",
      };
    },
  },
  activated() {
    this.refrenceInfo = this.$store.getters?.quoteResponse;
  },
  mounted() {
    this.refrenceInfo = this.$store.getters?.quoteResponse;
  },
  methods: {
    moveToBvooking() {
      let detailQuote = this.$store.getters.newQuoteStore;
      this.$store.dispatch("saveLatestNewShippingForSelf", false);
      this.$store.dispatch(
        "saveLatestPrevShipper",
        detailQuote?.shipperLocation
      );
      this.$store.dispatch(
        "saveLatestNewBookingConsignee",
        detailQuote?.consigneeLocation
      );
      this.$store.dispatch(
        "saveLatestNewBookinPackages",
        detailQuote?.packages
      );
      this.$store.dispatch(
        "actionQuoteShippingResponse",
        detailQuote?.shippingMethod
      );
      let splitval = {
        consignee: detailQuote?.consigneeLocation,
        prevShipper: detailQuote?.shipperLocation,
        shippingInformation: detailQuote,
        packages: detailQuote?.packages,
      };
      this.$store.dispatch("saveLatestInitialBookingData", splitval);
      this.$store.dispatch("saveLatestPrevShipper", detailQuote?.shipperLocation);
      this.$store.dispatch('setNewBookingShipmentMethod', detailQuote?.shippingMethod)
      this.$store.dispatch('saveLatestNewShippingForSelf', false)
      console.log(this.$store.getters, this.$store.getters.latestNewShippingForSelf)
      this.$router.push({ name: "BookingFlowNew" });
    },
    navigateToreciept() {
      localStorage.setItem("billing_reciept", "quote");


      this.$router.push(
        `/billing-collection/reciept/${this.refrenceInfo?.shipping?.transactionId}`
      );
    },
    navigateToReg() {
      localStorage.setItem("billing_reciept", "quote");
      this.$router.push({ name: "QuoteAndDraft" })
    },
  },
};
</script>

<style lang="scss" scoped>
.main-text {
  @apply py-4 pt-12;
  font-size: 35px;
}

.primary-button {
  @apply px-5 bg-primary-yellow py-3 rounded-md;
}
</style>
